import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import StarIcon from "../../../assets/event_icons/opportunity.png";
import { ChemistryPlayerPositions } from "../../../types/IOption";
import { hasPlayersFromDifferentClubs } from "../../../utils/drawChemistrys";

interface IAttributesBarProps{
    height: number;
    width: number;
    beforeValue: number;
    afterValue: number;
    inPlayerIds : number[];
    outPlayerIds : number[];
    color: string;
    ifStar?: boolean;
    positionResults: ChemistryPlayerPositions[]
    teamId: number
}

const AttributesBar : React.FC<IAttributesBarProps> = ({height , width , beforeValue, afterValue, inPlayerIds , outPlayerIds , color , ifStar, positionResults, teamId}) => {
  const svgRef = useRef<SVGSVGElement>(null);
//   const width = 200;
//   const height = 34;
    const margin = 2;
useEffect(() => {
  const svg = d3.select(svgRef.current!);
  svg.selectAll("*").remove(); // clear SVG before re-render

  const barHeight = height - margin;
  const scale = d3.scaleLinear().domain([0, 100]).range([0, width]);

  // main group
  const g = svg
    .append("g")
    .attr("width", width)
    .attr("height", height);

  // background bar
  g.append("rect")
    .attr("width", width - margin)
    .attr("height", height - margin)
    .attr("rx", 4)
    .attr("fill", "#F2F5EE")
    .attr("stroke", "#7C7D79")
    .attr("stroke-width", 1);


  // --- AFTER VALUE SECTION ---
  if (
    afterValue !== undefined &&
    inPlayerIds?.length > 0 &&
    outPlayerIds?.length > 0 &&
    hasPlayersFromDifferentClubs({positionResults, teamId})
  ) {
    const diffPositive = afterValue > beforeValue;
    const startX = diffPositive ? scale(beforeValue) : scale(afterValue);
    const diffWidth = Math.abs(scale(afterValue) - scale(beforeValue));

    g.append("rect")
            .attr("x", 1)
            .attr("y", 1)
          .attr("width", scale(beforeValue))
          .attr("height", barHeight - 2)
          .attr("rx", 4)
          .attr("fill", "#CFE6F4"); // base before color (neutral grey)

    g.append("line")
        .attr("x1", scale(beforeValue))
        .attr("x2", scale(beforeValue))
        .attr("y1", 1)
        .attr("y2", barHeight - 2)
        .attr("stroke", "#7C7D79")
        .attr("stroke-width", 1);

    // colored difference zone
    g.append("rect")
      .attr("x", startX)
      .attr("y", 1)
      .attr("width", diffWidth)
      .attr("height", barHeight - 2)
      .attr("fill", diffPositive ? "#00D1A8" : "#FF3864");

        // --- VALUE TEXTS ---
        g.append("text")
          .attr("x", 8)
          .attr("y", height / 2 + 4)
          .attr("text-anchor", "start")
          .style("font-family", "Aeonik")
          .style("font-size", "12px")
          .style("font-weight", 500)
          .style("fill", "black")
          .text(afterValue === 100 ? "99.99" : afterValue);

  }else{
        // --- BEFORE BAR ---
        g.append("rect")
            .attr("x", 1)
            .attr("y", 1)
          .attr("width", scale(beforeValue))
          .attr("height", barHeight - 2)
          .attr("rx", 4)
          .attr("fill", color); // base before color (neutral grey)

    g.append("line")
        .attr("x1", scale(beforeValue))
        .attr("x2", scale(beforeValue))
        .attr("y1", 1)
        .attr("y2", barHeight - 2)
        .attr("stroke", "#7C7D79")
        .attr("stroke-width", 1);

          // --- VALUE TEXTS ---
        g.append("text")
        .attr("x", 8)
        .attr("y", height / 2 + 4)
        .attr("text-anchor", "start")
        .style("font-family", "Aeonik")
        .style("font-size", "12px")
        .style("font-weight", 500)
        .style("fill", "black")
        .text(beforeValue === 100 ? "99.99" : beforeValue);
  }

  // optional star icon
  if (ifStar) {
    g.append("image")
      .attr("href", StarIcon)
      .attr("x", width < 300 ? scale(20) : scale(14))
      .attr("y", 5)
      .attr("width", 16)
      .attr("height", 16);
  }
}, [beforeValue, afterValue, ifStar, inPlayerIds, outPlayerIds, width, height, margin, positionResults, teamId, color]);



  return <svg ref={svgRef} width={width} height={height - margin}></svg>;
};

export default AttributesBar;
